import { atom } from 'jotai';
import { PaginatedPetParentReports } from '../types/petParentReports';

// Create atoms for storing report data
export const petParentReportsAtom = atom<PaginatedPetParentReports | null>(null);
